import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'
import '../../assets/scripts/jquery.lettering.js'
import '../../assets/scripts/jquery.textillate.js'

$("header .nav ul li").eq(0).addClass("active");

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
	pagination: {
    el: ".banner .swiper-pagination",
    clickable: true,
  },
}); 

 var industrial = new Swiper('.section1 .swiper-container', {
    centeredSlides: true,
    loop: true,
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 1.8,
        spaceBetween: '11.979167%',
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 1.8,
        spaceBetween: '11.979167%',
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 1,
        spaceBetween: 0,
      }
    },
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
    },
});

$(".product-nav ul li").eq(0).addClass("active");
$(".product-swiper .swiper-container").eq(0).addClass("active");
$(".product-text .text").eq(0).addClass("active");
$(".product-nav ul li").click(function() {
  let index = $(this).index();
  $(this).addClass("active").siblings().removeClass("active");
  $(".product-swiper .swiper-container").eq(index).addClass("active").siblings().removeClass("active");
  $(".product-text .text").eq(index).addClass("active").siblings().removeClass("active");
})

$(".section3 ul li").hover(function() {
  $(".section3 ul li .section-title").stop().slideUp();
  $(this).find(".section-title").stop().slideDown();
},function() {
  $(".section3 ul li .section-title").stop().slideUp();
})